//格式化日期  获取当月
const getNowMonth = (cun) => {
    let date = new Date();
    let myYear = date.getFullYear();
    let myMonth = date.getMonth() + 1;
    let myWeekDay = date.getDate();
    let week = date.getDay();
    myMonth < 10 ? (myMonth = "0" + myMonth) : myMonth;
    myWeekDay < 10 ? (myWeekDay = "0" + myWeekDay) : myWeekDay;
    if (cun === 1) {
        //获取年
        return myYear;
    } else if (cun === 2) {
        //获取月
        return myMonth;
    } else if (cun === 3) {
        //获取日
        return myWeekDay;
    } else if (cun === 4) {
        //获取周
        return week;
    } else if (cun === 5) {
        //获取有多少天
        let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return lastDay.getDate();
    } else {
        return myYear + '-' + myMonth + '-' + myWeekDay
    }
}

const getFirstDayOfWeekOfMonth = () => {
    // 获取当前日期
    let today = new Date();

    // 设置日期为当月的第一天
    today.setDate(1);

    // 获取第一天是周几（0-周日，1-周一，...，6-周六）
    let dayOfWeek = today.getDay();

    return dayOfWeek;
}


export {getNowMonth, getFirstDayOfWeekOfMonth}